import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.powder,
  iconColor: colors.dirtBrown,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.metal,
  textColorLight: colors.white
};
export default accordion;